export default class ProofreadHist {
  static hist = [];
  static idx = 0;

  static init(data) {
    this.hist = [];
    this.push(data);
    this.idx = 0;
  }

  static push(data) {
    if (this.hist.length > 0 && this.hist[this.hist.legnth-1] === data) return;
    if (this.hist.length > this.idx+1) this.hist = this.hist.slice(0, this.idx+1);
    this.hist.push(data);
    this.idx++;
  }

  static prev() {
    if (this.idx < 0) return null;
    return this.hist[--this.idx];
  }

  static next() {
    if (this.hist.length <= this.idx + 1) return null;
    return this.hist[++this.idx];
  }

  static hasPrev() {
    return this.idx > 0;
  }
  static hasNext() {
    return this.hist.length > this.idx+1;
  }
}